export default __webpack_public_path__ + "static/media/mystical-eyes.1f306076.jpg";